/* eslint-disable @typescript-eslint/no-unused-vars */
import { GameMetaParams, MOVE_TIME_LOGIC_BY_MODE } from '../constants';

/* do not delete unused declarations, eval need them in scope  */
export const random = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};
const max = Math.max;

export const getBotThinkingTimeMS = ({ mode, movesCount }: GameMetaParams) => {
  const [, time = ''] = Object.entries(MOVE_TIME_LOGIC_BY_MODE[mode]).find(([condition]) => eval(condition)) || [];
  return eval(time) * 1000;
};
